<template>
  <section class="emmaus-wrap py-5">
    <div class="container">

      <!-- Titre -->
      <p class="emmaus-intro text-center mb-5">
        Avec le Christ, Maître d’initiation, devenir des disciples d’Emmaüs
        (Lc 24, 13-35)
      </p>

      <!-- Étapes -->
      <div class="row g-4 mb-5">
        <div class="col-md-4" v-for="(step, i) in steps" :key="i">
          <div class="emmaus-card">
            <div class="emmaus-number">{{ i + 1 }}</div>
            <p>{{ step }}</p>
          </div>
        </div>
      </div>

      <!-- Modules -->
      <h4 class="section-subtitle text-center mb-3">Modules de formation</h4>
      <div class="modules text-center mb-5">
        <span class="module" v-for="(m, i) in modulesIntro" :key="i">
          {{ m }}
        </span>
      </div>

      <!-- Groupes -->
      <div class="row g-4 mb-5">
        <div class="col-md-4" v-for="(g, i) in groups" :key="i">
          <div class="group-card">
            <h5>{{ g.name }}</h5>
            <p>{{ g.time }}</p>
          </div>
        </div>
      </div>

      <!-- Raisons -->
      <div class="reasons mb-5">
        <h4 class="section-subtitle text-center mb-3">
          5 bonnes raisons pour s’inscrire au Parcours Disciple d’Emmaüs 
        </h4>
        <ul>
          <li v-for="(r, i) in reasons" :key="i">
            {{ r }}
          </li>
        </ul>
      </div>

      <!-- Infos -->
      <div class="info-box mb-4">
        <p><strong>Durée :</strong> Trois séances de 2h30 par semaine sur deux ans</p>
        <p><strong>Frais d’inscription :</strong> 10 000 FCFA (1ère année)</p>
        <p>
          <strong>Accompagnement :</strong> Tutorat, suivi institutionnel,
          rattrapage des cours possible
        </p>
      </div>

      <!-- Boutons -->
      <div class="text-center">
        <a href="/Depliant2.pdf" 
        download="Depliant2"
        class="btn-download me-3">
          Télécharger le dépliant
        </a>
        <a href="/FicheInscription.pdf" 
        download="FicheInscription"
        class="btn-outline">
          Télécharger Fiche d'Inscription
        </a>
      </div>

    </div>
    <br><br><br><br>
    <div class="container">
        <h4 class="section-subtitle text-center mb-3">
          La liste des cours
        </h4>
      <!-- Onglets -->
      <div class="year-tabs text-center mb-4">
        <button
          class="year-tab"
          :class="{ active: activeYear === 1 }"
          @click="activeYear = 1"
        >
          1ère année
        </button>
        <button
          class="year-tab"
          :class="{ active: activeYear === 2 }"
          @click="activeYear = 2"
        >
          2ème année
        </button>
      </div>

      <!-- Contenu année -->
      <div v-for="year in years" :key="year.id">
        <div v-if="activeYear === year.id">

          <h4 class="year-title text-center mb-2">
            {{ year.title }}
          </h4>
          <p class="year-note text-center mb-4">
            {{ year.note }}
          </p>

          <!-- Modules -->
          <div class="row g-4">
            <div
              class="col-md-6"
              v-for="(module, i) in year.modules"
              :key="i"
            >
              <div class="module-card">
                <h5 class="module-title">{{ module.name }}</h5>
                <ul>
                  <li v-for="(course, j) in module.courses" :key="j">
                    {{ course }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Coût -->
          <div class="cost-box mt-5">
            <h4>Coût de la formation</h4>
            <p>
              <strong>{{ year.cost }}</strong>
              
            </p>
          </div>

        </div>
      </div>

    </div>
  </section>
</template>

<script lang="ts">
export default {
  name: "ParcoursEmmaus",
  data() {
    return {
      /* ====== CONTENU GÉNÉRAL ====== */
      steps: [
        "Se mettre en marche ensemble",
        "Être portés par de saines et saintes inquiétudes",
        "Se nourrir de la Parole de Dieu",
        "Reconnaître le Christ à la fraction du pain",
        "Prendre sa part à la mission"
      ],

      modulesIntro: [
        "Bible",
        "Théologie",
        "Histoire de l’Église",
        "Vie de foi",
        "Culture générale"
      ],

      groups: [
        { name: "Groupe 1", time: "Lundi • Mardi • Jeudi (16h – 18h45)" },
        { name: "Groupe 2", time: "Lundi • Mardi • Jeudi (19h – 21h45)" },
        { name: "Groupe 3", time: "Vendredi (19h – 21h45) & Samedi (8h30 – 13h)" }
      ],

      reasons: [
        "Je développe une relation plus approfondie avec le Christ",
        "Je connais mieux ce que je crois et en qui je crois",
        "Je connais mieux mon Église et je la sers",
        "Je dispose d’arguments solides pour défendre ma foi",
        "Je me forme au témoignage chrétien dans la société à partir de ma foi"
      ],

      /* ====== ANNÉES & COURS ====== */
      activeYear: 1,

      years: [
        {
          id: 1,
          title: "1ère année",
          note: "Certains cours sont donnés en mode cyclique avec la 2ème année",
          cost: "140 000 FCFA (hors activités), payables en trois tranches",
          modules: [
            {
              name: "Bible",
              courses: [
                "Bible : Parole de Dieu ou paroles d’homme",
                "Révélation de Dieu dans la création et dans l’histoire de son peuple",
                "Les psaumes : paroles magiques ou paroles de foi",
                "Introduction aux prophètes"
              ]
            },
            {
              name: "Théologie",
              courses: [
                "Introduction à la Théologie",
                "La Création",
                "Foi et raison",
                "L’existence de Dieu",
                "Le mystère de Dieu Un et Trine"
              ]
            },
            {
              name: "Histoire de l’Église",
              courses: [
                "L’Église en fondation",
                "L’Église définit sa foi"
              ]
            },
            {
              name: "Vie de foi",
              courses: [
                "Introduction à la liturgie",
                "Année liturgique et piété populaire",
                "Principes de la spiritualité chrétienne",
                "Lectio divina",
                "Le peuple de Dieu",
                "Les biens temporels",
                "Morale chrétienne – Veritatis Splendor",
                "Doctrine sociale"
              ]
            },
            {
              name: "Culture générale",
              courses: [
                "Importance de la philosophie pour la théologie",
                "Transmission et communication de la foi",
                "Notre corps : un don",
                "Méthodologie",
                "Initiation au latin"
              ]
            }
          ]
        },
        {
          id: 2,
          title: "2ème année",
          note: "Certains cours sont donnés en mode cyclique avec la 1ère année",
          cost: "140 000 FCFA (hors activités), payables en trois tranches",
          modules: [
            {
              name: "Bible",
              courses: [
                "Les Évangiles",
                "Comprendre l’Église aujourd’hui (Actes et Saint Paul)",
                "Christ et les sacrifices anciens",
                "L’Apocalypse"
              ]
            },
            {
              name: "Théologie",
              courses: [
                "Christologie",
                "Dominus Iesus",
                "L’Esprit-Saint, l’Église et Marie",
                "Les fins dernières et le temps présent",
                "La grâce – L’Eucharistie",
                "Le péché originel et la Rédemption"
              ]
            },
            {
              name: "Histoire de l’Église",
              courses: [
                "L’Église se réforme",
                "L’Église en mission"
              ]
            },
            {
              name: "Vie de foi",
              courses: [
                "Les Sacrements et Sacramentaux : fondements",
                "Rituel et célébration",
                "Les peines dans l’Église",
                "Le droit matrimonial",
                "Vie des saints",
                "La sainteté en Afrique",
                "Questions bioéthiques",
                "Le chrétien dans la cité"
              ]
            },
            {
              name: "Culture générale",
              courses: [
                "Grandes tendances contemporaines",
                "Histoire Église Mémoire",
                "Étude Iuvenescit Ecclesia",
                "Initiation au grec / hébreu",
                "Méthodologie"
              ]
            }
          ]
        }
      ]
    }
  }
}
</script>

<style scoped>
.emmaus-wrap {
  background: #f8f9fa;
}

.emmaus-title {
  color: #0b1b3f;
  font-weight: 800;
}

.emmaus-intro {
  color: #6c757d;
  font-size: 1.1rem;
}

.section-subtitle {
  color: #0b1b3f;
  font-weight: 700;
}

.emmaus-card {
  background: #fff;
  padding: 25px;
  border-radius: 16px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  text-align: center;
  transition: transform 0.3s ease;
}

.emmaus-card:hover {
  transform: translateY(-6px);
}

.emmaus-number {
  width: 48px;
  height: 48px;
  background: #ffc107;
  color: #0b1b3f;
  font-weight: 800;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
}

.modules {
  max-width: 800px;
  margin: auto;
}

.module {
  background: #0b1b3f;
  color: #fff;
  padding: 8px 16px;
  border-radius: 25px;
  margin: 6px;
  display: inline-block;
  font-size: 0.9rem;
}

.group-card {
  background: #fff;
  padding: 22px;
  border-radius: 14px;
  border-left: 5px solid #ffc107;
  height: 100%;
}

.group-card h5 {
  color: #0b1b3f;
  font-weight: 700;
}

.reasons ul {
  max-width: 700px;
  margin: auto;
  padding: 0;
  list-style: none;
}

.reasons li {
  padding: 12px;
  border-bottom: 1px dashed #ccc;
  color: #555;
}

.info-box {
  background: #fff;
  border-left: 6px solid #0b1b3f;
  padding: 20px;
  border-radius: 12px;
  max-width: 800px;
  margin: auto;
  color: #555;
}

.btn-download {
  background: #ffc107;
  color: #0b1b3f;
  font-weight: 700;
  padding: 12px 26px;
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.btn-download:hover {
  background: #e0a800;
  transform: translateY(-2px);
}

.btn-outline {
  border: 2px solid #0b1b3f;
  color: #0b1b3f;
  padding: 12px 26px;
  border-radius: 10px;
  font-weight: 700;
  text-decoration: none;
}

.emmaus-wrap {
  background: #f8f9fa;
}

.emmaus-title {
  color: #0b1b3f;
  font-weight: 800;
}

.emmaus-intro {
  color: #6c757d;
}

.year-tabs {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.year-tab {
  padding: 10px 25px;
  border-radius: 25px;
  border: 2px solid #0b1b3f;
  background: transparent;
  font-weight: 700;
  color: #0b1b3f;
  cursor: pointer;
}

.year-tab.active {
  background: #ffc107;
  border-color: #ffc107;
}

.year-title {
  color: #0b1b3f;
  font-weight: 700;
}

.year-note {
  color: #6c757d;
}

.module-card {
  background: white;
  padding: 22px;
  border-radius: 14px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
  height: 100%;
}

.module-title {
  color: #0b1b3f;
  font-weight: 700;
  margin-bottom: 10px;
}

.module-card ul {
  padding-left: 18px;
}

.module-card li {
  font-size: 0.95rem;
  color: #555;
  margin-bottom: 6px;
}

.cost-box {
  background: white;
  border-left: 6px solid #ffc107;
  padding: 25px;
  border-radius: 14px;
  max-width: 700px;
  margin: auto;
  text-align: center;
}
</style>
